<template>
  <div
    v-if="!evaluator_view && !evaluatee_view && !preview_evaluation"
    class="noprint"
  >
    <!-- Test Correcto -->
    <div>
      <div
        v-if="
          test.is_valid == true &&
          test.evaluative_agent != null &&
          test.evaluation_situation != null
        "
        :class="{
          'alert alert-success': test.manual_is_valid == true,
          'alert alert-info': test.manual_is_valid == false,
        }"
      >
        <div class="d-flex justify-content-center">
          <div
            v-if="test.manual_is_valid == false"
            class="align-content-center"
          >
            <strong>
              {{ $getVisibleNames("evaluations2.test", false, "Instrumento") }}
            </strong>
            {{ $t("evaluations.newEvaluations.readyToClose") }}
            <!-- Tooltip para Secciones -->
            <InfoTooltip
              v-if="evaluation && evaluation.scope == 1"
              :tooltip_text="
                $t('evaluations.newEvaluations.instrumentIsValid', {
                  entity: $getVisibleNames(
                    'evaluations2.test',
                    false,
                    'Instrumento'
                  ),
                })
              "
            ></InfoTooltip>
            <!-- Tooltip para los Administrativos -->
            <InfoTooltip
              v-if="evaluation && evaluation.scope == 3"
              :tooltip_text="
                $t(
                  'evaluations.newEvaluations.closingInstrumentAllowsActions',
                  {
                    entity: $getVisibleNames(
                      'evaluations2.test',
                      false,
                      'Instrumento'
                    ),
                  }
                )
              "
            ></InfoTooltip>
          </div>
          <div v-if="test.manual_is_valid == true" class="align-content-center">
            <strong>
              {{ $getVisibleNames("evaluations2.test", false, "Instrumento") }}
            </strong>
            {{ $t("evaluations.newEvaluations.closed") }}
          </div>
          <ButtonMedium
            v-if="allows_crud && test.manual_is_valid == false"
            :tooltip_text="
              $t('evaluations.newEvaluations.pressToCloseInstrument', {
                entity: $getVisibleNames(
                  'evaluations2.test',
                  false,
                  'Instrumento'
                ),
              })
            "
            :text_button="``"
            :click_button="changeStateManualIsValid"
            :icon="'unlock'"
            :variant="'warning'"
            :custom_class="`ml-2`"
            :disabled_button="disabled_button"
          >
          </ButtonMedium>
          <!-- <b-button
            v-if="allows_crud && test.manual_is_valid == false"
            variant="info"
            size="sm"
            class="ml-3"
            @click="changeStateManualIsValid()"
            :disabled="disabled_button"
          >
            Cerrar
            {{ $getVisibleNames("evaluations2.test", false, "Instrumento") }}
          </b-button> -->

          <ButtonMedium
            v-if="allows_crud && test.manual_is_valid == true"
            :tooltip_text="
              $t('evaluations.newEvaluations.pressToReopenInstrument', {
                entity: $getVisibleNames(
                  'evaluations2.test',
                  false,
                  'Instrumento'
                ),
              })
            "
            :text_button="``"
            :click_button="changeStateManualIsValid"
            :icon="'lock'"
            :variant="'warning'"
            :custom_class="`ml-2`"
            :disabled_button="disabled_button"
          >
          </ButtonMedium>
          <!-- <b-button
            v-if="allows_crud && test.manual_is_valid == true"
            variant="warning"
            size="sm"
            class="ml-3"
            @click="changeStateManualIsValid()"
            v-b-tooltip.v-secondary.top.noninteractive.hover="
              `Si desea volver a abrir la ${$getVisibleNames(
                'evaluations2.test',
                false,
                'Instrumento'
              )} presione este botón`
            "
          >
            Abrir
            {{ $getVisibleNames("evaluations2.test", false, "Instrumento") }}
          </b-button> -->
        </div>
      </div>
    </div>
    <!-- Test  con Fallos -->
    <div
      v-if="
        test.is_valid[1] ||
        test.evaluative_agent == null ||
        test.evaluation_situation == null
      "
      class="alert alert-danger"
    >
      <div class="d-flex justify-content-center">
        <div class="align-content-center">
          <strong>{{ $t("evaluations.newEvaluations.problemsFound") }}</strong>
        </div>
        <ButtonMedium
          :tooltip_text="$t('evaluations.newEvaluations.pressToViewErrors')"
          :text_button="``"
          :click_button="
            () =>
              $bvModal.show(
                `modal-close-instrument-${test.id}-${container_instrument_id}`
              )
          "
          :icon="'exclamation'"
          :variant="'danger'"
          :custom_class="`ml-2`"
        >
        </ButtonMedium>
        <!-- <b-button
          variant="danger"
          size="sm"
          class="ml-2"
          @click="
            $bvModal.show(
              `modal-close-instrument-${test.id}-${container_instrument_id}`
            )
          "
        >
          Información de errores
        </b-button> -->
      </div>
    </div>

    <!-- Modal Cerrar instrumento -->
    <b-modal
      :id="`modal-close-instrument-${test.id}-${container_instrument_id}`"
      :title="
        $t('evaluations.newEvaluations.informationOf', {
          entity: $getVisibleNames('evaluations2.test', false, 'Instrumento'),
        })
      "
      hide-footer
      size="xl"
    >
      <InfoTestTable :test="test"></InfoTestTable>
    </b-modal>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { toast } from "../../../utils/utils";
import { mapGetters } from "vuex";

export default {
  name: "InfoTest",
  components: {
    InfoTestTable: () =>
      import("@/components/new-evaluations/Evaluation/InfoTestTable"),
    InfoTooltip: () => import("@/components/reusable/InfoTooltip"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
  },
  props: {
    test: {
      type: Object,
      required: true,
    },
    evaluation_id: {
      type: Number,
      required: true,
    },
    container_instrument_id: {
      type: String,
    },
    evaluatee_view: {
      type: Boolean,
    },
    evaluator_view: {
      type: Boolean,
    },
    preview_evaluation: {
      type: Boolean,
    },
    allows_crud: {
      type: Boolean,
    },
  },
  data() {
    return {
      disabled_button: false,
    };
  },
  computed: {
    ...mapGetters({
      // rubricInstances: names.NEW_RUBRIC_CRITERIAS,
      // evaluation_criteria_micros: names.EVALUATION_CRITERIAS,
      evaluations: names.NEW_EVALUATIONS,
    }),
    evaluation() {
      return this.evaluations.find((x) => x.id == this.evaluation_id);
    },
  },
  methods: {
    changeStateManualIsValid() {
      if (this.evaluation && this.evaluation.scope == 1) {
        if (this.test.manual_is_valid == false) {
          this.$swal({
            title: `<p>${this.$t("evaluations.newEvaluations.closeEntity", {
              entity: this.$getVisibleNames(
                "evaluations2.test",
                false,
                "Instrumento"
              ),
            })}</p>`,
            text: this.$t(
              "evaluations.newEvaluations.closingWillMakeAvailableToEvaluatees",
              {
                entity: this.$getVisibleNames(
                  "evaluations2.test",
                  false,
                  "Instrumento"
                ),
              }
            ),
            type: "warning",
            showCancelButton: true,
          }).then((result) => {
            if (result.value) {
              this.disabled_button = true;
              this.$store
                .dispatch(names.PATCH_NEW_TEST, {
                  new_test_id: this.test.id,
                  item: {
                    manual_is_valid: !this.test.manual_is_valid,
                    visible_by_evaluatees: !this.test.visible_by_evaluatees
                      ? !this.test.visible_by_evaluatees
                      : this.test.visible_by_evaluatees,
                  },
                })
                .then(() => {
                  toast(
                    this.$t("evaluations.newEvaluations.closedSuccessfully", {
                      entity: this.$getVisibleNames(
                        "evaluations2.test",
                        false,
                        "Instrumento"
                      ),
                    })
                  );
                  this.disabled_button = false;
                });
            }
          });
        } else if (this.test.manual_is_valid == true) {
          this.$swal({
            title: `<p>${this.$t("evaluations.newEvaluations.openEntity", {
              entity: this.$getVisibleNames(
                "evaluations2.test",
                false,
                "Instrumento"
              ),
            })}</p>`,
            text: this.$t(
              "evaluations.newEvaluations.openingWillMakeUnavailableToEvaluatees",
              {
                entity: this.$getVisibleNames(
                  "evaluations2.test",
                  false,
                  "Instrumento"
                ),
              }
            ),
            type: "warning",
            showCancelButton: true,
          }).then((result) => {
            if (result.value) {
              this.disabled_button = true;
              this.$store
                .dispatch(names.PATCH_NEW_TEST, {
                  new_test_id: this.test.id,
                  item: {
                    manual_is_valid: !this.test.manual_is_valid,
                    visible_by_evaluatees: !this.test.visible_by_evaluatees
                      ? this.test.visible_by_evaluatees
                      : !this.test.visible_by_evaluatees,
                  },
                })
                .then(() => {
                  toast(
                    this.$t("evaluations.newEvaluations.openedSuccessfully", {
                      entity: this.$getVisibleNames(
                        "evaluations2.test",
                        false,
                        "Instrumento"
                      ),
                    })
                  );
                  this.disabled_button = false;
                });
            }
          });
        }
      } else {
        this.disabled_button = true;
        this.$store
          .dispatch(names.PATCH_NEW_TEST, {
            new_test_id: this.test.id,
            item: {
              manual_is_valid: !this.test.manual_is_valid,
            },
          })
          .then((response) => {
            if (response.manual_is_valid) {
              toast(
                this.$t("evaluations.newEvaluations.closedSuccessfully", {
                  entity: this.$getVisibleNames(
                    "evaluations2.test",
                    false,
                    "Instrumento"
                  ),
                })
              );
            } else {
              toast(
                this.$t("evaluations.newEvaluations.openedSuccessfully", {
                  entity: this.$getVisibleNames(
                    "evaluations2.test",
                    false,
                    "Instrumento"
                  ),
                })
              );
            }
            this.disabled_button = false;
          });
      }
    },
  },
  created() {},
};
</script>

<style scoped>
.icon-lock-margin {
  margin-bottom: 2px !important;
}
</style>